import { VSFPD3Chart } from "../../../d3charts/vsfp/VSFPD3Chart"

export const VSFPChartConfig = ({
  data,
  width,
  height,
  config,
  lRef,
  palette
}) => {
  return (
    <VSFPD3Chart
      data={data}
      width={width}
      height={height}
      config={config}
      lRef={lRef}
      palette={palette}
    />
  );
};
